import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import BindingResult from "./BindingResult";
import liffClient from "./services/liffClient";
import PhoneBinding from "./PhoneBinding";

export default function LiffApp() {
  const [isInitialized, setIsInitialized] = useState(false);
  const [initializationFailed, setInitializationFailed] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        await liffClient.initialize();

        setIsInitialized(true);
      } catch {
        setInitializationFailed(true);
      }
    };

    initialize();
  }, []);

  if (!isInitialized && !initializationFailed) return null;

  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-[440px] flex-col bg-[#EBEBEB] px-12">
      {initializationFailed ? (
        <BindingResult type="error" />
      ) : (
        <RouterProvider router={router} />
      )}
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "/line/user/phone-binding",
    element: <PhoneBinding />,
  },
]);
